import { ApolloError, FetchPolicy, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { getCountryWithSGFallback } from 'src/modules/ClientConfig/Selectors';

import { getPopularSearchesQuery } from '../graphql';

export interface PopularSearchesResult {
  popularSearches?: string[];
  loading: boolean;
  error?: ApolloError;
}

export const useGetPopularSearchesData = () => {
  const countryCode = useSelector(getCountryWithSGFallback);
  const queryOptions = {
    variables: {
      countryCode,
    },
    fetchPolicy: 'cache-first' as FetchPolicy,
  };

  const { data, loading, error } = useQuery<{
    popularSearches: string[];
  }>(getPopularSearchesQuery, queryOptions);

  return {
    popularSearches: data?.popularSearches,
    loading,
    error,
  };
};
